import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

// eslint-disable-next-line react/display-name
export default (props) => (
  <Modal isOpen={props.isOpen} toggle={props.toggle} className={props.className} contentClassName={props.contentClassName} backdrop={props.backdrop}>
    {props.header && <ModalHeader toggle={props.showClose ? props.toggle : null}>{props.header}</ModalHeader>}

    <ModalBody>{props.body || null}</ModalBody>

    {props.footer && <ModalFooter>{props.footer}</ModalFooter>}
  </Modal>
)
